export default (node) => {
  const mtoText = node.querySelector('[data-mto-text]');
  const preorderText = node.querySelector('[data-preorder-text]');
  const closeModal = node.querySelectorAll('[data-close-modal]');

  const init = () => {
    document.addEventListener('stock:error', (e) => {
      const variant = e.detail.variant;

      node.classList.add('stock-error-modal-visible');
      if (variant === 'mto') {
        mtoText.classList.remove('hidden');
        preorderText.classList.add('hidden');
      } else {
        mtoText.classList.add('hidden');
        preorderText.classList.remove('hidden');
      }
    });

    closeModal.forEach((el) => {
      el.addEventListener('click', () => {
        node.classList.remove('stock-error-modal-visible');
      });
    });
  };

  init();
};
